import types from './types'
import actions from './actions'

let createDefaultFilters = () => {
  return [{
    type: 'radio',
    prop: 'is_active',
    value: null
  }, {
    type: 'search',
    prop: 'q',
    value: ''
  }]
}

export default {
  namespaced: true,

  state: {
    staffs: [],
    total: 0,
    currentStaff: {},
    currentPage: 1,
    filters: createDefaultFilters(),
    pageSize: 20,
    editStaffDialogVisible: false,
    adding: true,
    loading: false
  },

  getters: {
    queryInfo: ({ currentPage: page, pageSize: per_page, filters }, getter, rootState) => {
      return {
        page,
        per_page,
        is_active: filters[0].value,
        q: filters[1].value,
        role_id: rootState.roles.currentRole.id
      }
    }
  },

  mutations: {
    [types.REFRESH](state, { staffs, total }) {
      state.staffs = staffs
      state.total = total
    },
    [types.ADD](state, newStaff) {
      state.staffs.unshift(newStaff)
    },
    [types.DELETE](state, index) {
      state.staffs.splice(index, 1)
    },
    [types.UPDATE](state, updatedStaff) {
      Object.assign(state.currentStaff, updatedStaff)
    },
    [types.UPDATE_FILTERS](state, newFilters) {
      state.filters = newFilters
    },
    [types.CHANGE_PAGE](state, newPage) {
      state.currentPage = newPage
    },
    [types.CHANGE_PAGE_SIZE](state, newPageSize) {
      state.pageSize = newPageSize
    },
    [types.CHANGE_CURRENT_STAFF](state, currentStaff) {
      state.currentStaff = currentStaff
    },
    [types.OPEN_DIALOG_FOR_ADDING](state) {
      state.adding = true
      state.editStaffDialogVisible = true
    },
    [types.OPEN_DIALOG_FOR_UPDATING](state, row) {
      state.adding = false
      state.editStaffDialogVisible = true
      state.currentStaff = row
    },
    [types.UPDATE_STAFF_DIALOG_VISIBLE](state, visible) {
      state.editStaffDialogVisible = visible
    },
    [types.CHANGE_LOADING](state, loading) {
      state.loading = loading
    },
    [types.RESET_QUERY_INFO](state) {
      state.currentPage = 1
      state.pageSize = 20
      state.filters = createDefaultFilters()
    }
  },

  actions
}
